import { gql } from 'urql';

const GetCountries = gql`
  query CountryList {
    countries {
      name
      countryCode
    }
  }
`;

export default GetCountries;
